import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { Box } from '@machobear/design-system'

import Map from '@/components/maplibre-map/map'
import Marker from '@/components/maplibre-map/marker'

interface ListingMapProps {
  coordinates: {
    lat: number
    lng: number
  }
  zoom: number
}

const ListingMap = ({ coordinates, zoom }: ListingMapProps) => {
  const { t } = useTranslation()
  const coords: [number, number] = [coordinates.lat, coordinates.lng]

  return (
    <Box
      width="full"
      borderRadius="standard"
      overflow="hidden"
      style={{ height: '260px' }}
      background="neutralLight"
    >
      <Map
        center={coords}
        zoom={zoom}
        navigationControl={{ enabled: false }}
        scrollZoom={false}
        dragPan={false}
      >
        <Marker
          position={coords}
          text={t(
            'l.listing.create.listing_map_marker.text',
            'Your exact location will be displayed by default, but you can choose to hide it if you prefer.'
          )}
        />
      </Map>
    </Box>
  )
}

export default memo(ListingMap)
